import { FC } from 'react';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import { operationTableHeaderMap } from '../constants/operationTableHeaderMap';

const OperationDetailsTableHeader: FC = () => {
  const { data } = useOperationDetailsPage();

  const OperationComponent =
    data.operation?.operationType &&
    operationTableHeaderMap[data.operation.operationType];

  return (OperationComponent && <OperationComponent />) || null;
};

export default OperationDetailsTableHeader;
